module.exports = __webpack_public_path__ + "img/15passenger_driving.1e50ac5c.svg";